import React from 'react'
import { Box, Typography, Alert } from '@mui/material'

/**
 * Assignments Section Component - STUB
 * TODO: Implement brand→location→chamber assignment tree
 */
export default function AssignmentsSection({ data, onChange, disabled, loading, error }) {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Clinic Brand & Location Assignment
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        TODO: Implement brand → location → chamber assignment interface
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Alert severity="info">
        This section needs implementation. See SPRINT.md for details.
      </Alert>
    </Box>
  )
}
